$(function (){
	let sharers = [...document.querySelectorAll(".social-share, .content-actions, .hero__social")];
	if (!!sharers.length) {
		sharers.forEach(share => {
			let links = [...share.querySelectorAll("a.social-share__link, a.content-actions__share-link, a.hero__social-link")];
			links.forEach(link => {
				let shareHref;
				let encodedUrl = encodeURIComponent(document.URL);
				let title = document.querySelector("meta[property='og:description']")?.getAttribute("content") || document.querySelector("title")?.textContent || "";
				if (link.matches("[class*=facebook]")) {
					shareHref = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
				} else if (link.matches("[class*=twitter], [class*=x-logo]")) {
					shareHref = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodeURI(title)}`;
				} else if (link.matches("[class*=linkedin], [class*=linked-in]")) {
					shareHref = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
				} else if (link.matches("[href*=mailto]") || link.matches("[class*=mail]")) {
					shareHref = "mailto:?body=" + encodedUrl;
				}
				link.setAttribute("target", "_blank");
				link.setAttribute("href", shareHref);
			});
		});
	}
});